import React, {Component} from 'react';
import {
    FacebookIcon,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
} from "react-share";

import FacebookShareButton from './OverridingComponents/FacebookShareButton';
import FacebookShareCount from './OverridingComponents/FacebookShareCount';
import Alert from "react-s-alert";
import {SOCIAL_MEDIA} from "../../../../analytics/config/analyticsParamsFrontEnd";


export default class ShareButtonsBox extends Component {
    
    constructor(props) {
        super(props);
        
        this.onClickCopyLink = this.onClickCopyLink.bind(this);
        this.onClickFacebook = this.onClickFacebook.bind(this);
        this.onClickTwitter = this.onClickTwitter.bind(this);
        this.onClickWhatsapp = this.onClickWhatsapp.bind(this);
        this.onClickTelegram = this.onClickTelegram.bind(this);
        this.renderStickyBottomSocialMedia = this.renderStickyBottomSocialMedia.bind(this);
        this.copyLinkToClipboard = this.copyLinkToClipboard.bind(this);
        
    }
    onClickFacebook() {
        console.log("ShareButtonsBox::onClickFacebook()");
        this.props.onClickShareButton(SOCIAL_MEDIA.FACEBOOK)
    }
    onClickTwitter() {
        console.log("ShareButtonsBox::onClickFacebook()");
        this.props.onClickShareButton(SOCIAL_MEDIA.TWITTER)
    }
    onClickWhatsapp() {
        console.log("ShareButtonsBox::onClickWhatsappButton()");
        this.props.onClickShareButton(SOCIAL_MEDIA.WHATSAPP)
    }
    onClickTelegram() {
        console.log("ShareButtonsBox::onClickTelegram()");
        this.props.onClickShareButton(SOCIAL_MEDIA.TELEGRAM)
    }
    
    
    renderStickyBottomSocialMedia() {
        
        
        return (<div className="entry-social social-sticky all social-bottom social-center  social-count">
            
            <a href="#" className="social social-facebook" data-social-ready="true">
                <FacebookShareButton
                    url={this.props.shareURL}
                    quote={this.props.text}
                    hashtag={'#' + this.props.hashtags.join(',#')}
                    app_id={process.env.FACEBOOK_APP_ID}
                    className="share-button-network "
                    beforeOnClick={this.onClickFacebook}
                >
                    
                    <i className="lab la-lg la-facebook-f"/>
                </FacebookShareButton>
            </a>
            <a href="#" className="social social-twitter" data-social-ready="true">
                <TwitterShareButton
                    url={this.props.shareURL}
                    title={this.props.text}
                    hashtags={this.props.hashtags}
                    via={"AdoptaunanimalE"}
                    className="share-button-network "
                    beforeOnClick={this.onClickTwitter}
                >
                    
                    <i className="lab la-lg la-twitter"/>
                </TwitterShareButton>
            </a>
            <a href="#" className="social social-whatsapp" data-social-ready="true">
                <WhatsappShareButton
                    className="share-button-network "
                    url={(this.props.shareURL.endsWith("/") ? this.props.shareURL : this.props.shareURL + "/") + "?utm_source=whatsapp"}
                    title={this.props.text}
                    separator=":: "
                    beforeOnClick={this.onClickWhatsapp}>
                    
                    <i className="lab la-lg la-whatsapp"/>
                </WhatsappShareButton>
            </a>
            <a href="#" className="social social-telegram" data-social-ready="true">
                <TelegramShareButton
                    url={(this.props.shareURL.endsWith("/") ? this.props.shareURL : this.props.shareURL + "/") + "?utm_source=telegram"}
                    title={this.props.text}
                    separator=":: "
                    beforeOnClick={this.onClickTelegram}
                    className="share-button-network ">
                    <i className="lab la-lg la-telegram"/>
                </TelegramShareButton>
            </a>
            <a href="#" className="social social-email" data-social-ready="true">
                <div className="share-buttons-box-network">
                    <span onClick={this.onClickCopyLink} className="share-button-network">
                        <i className="las la-lg la-link"/>
                    </span>
                </div>
            </a>
        
        </div>)
    }
    
    render() {
        return (
            <div>
                {this.props.stickyMode && this.renderStickyBottomSocialMedia()}
                {this.props.normalMode &&
                    <div className="share-buttons-box-container">
                        
                        <div className="share-buttons-box-network">
                            <FacebookShareButton
                                url={this.props.shareURL}
                                quote={this.props.text}
                                hashtag={'#' + this.props.hashtags.join(',#')}
                                app_id={process.env.FACEBOOK_APP_ID}
                                beforeOnClick={this.onClickFacebook}
                                className="share-button-network ">
    
                                <FacebookIcon size={42} round/>
                            </FacebookShareButton>
                            <div>
                                {/*<FacebookShareCount url={this.props.shareURL} className="share-button-network-count">*/}
                                {/*    {engagement => engagement.count}*/}
                                {/*</FacebookShareCount>*/}
                            </div>
                        </div>
                        
                        <div className="share-buttons-box-network">
                            <TwitterShareButton
                                url={this.props.shareURL}
                                title={this.props.text}
                                hashtags={this.props.hashtags}
                                via={"AdoptaunanimalE"}
                                beforeOnClick={this.onClickTwitter}
                                className="share-button-network ">
                                
                                <TwitterIcon size={42} round/>
                            </TwitterShareButton>
                            
                            <div className="share-button-network-count">&nbsp;</div>
                        </div>
                        
                        <div className="share-buttons-box-network ">
                            <WhatsappShareButton
                                url={(this.props.shareURL.endsWith("/") ? this.props.shareURL : this.props.shareURL + "/") + "?utm_source=whatsapp"}
                                title={this.props.text}
                                separator=":: "
                                beforeOnClick={this.onClickWhatsapp}
                                className="share-button-network ">
                                
                                <WhatsappIcon size={42} round/>
                            </WhatsappShareButton>
                            
                            <div className="share-button-network-count">&nbsp;</div>
                        </div>
                        <div className="share-buttons-box-network ">
                            <TelegramShareButton
                                url={(this.props.shareURL.endsWith("/") ? this.props.shareURL : this.props.shareURL + "/") + "?utm_source=telegram"}
                                title={this.props.text}
                                separator=":: "
                                beforeOnClick={this.onClickTelegram}
                                className="share-button-network ">
                                
                                <TelegramIcon size={42} round/>
                            </TelegramShareButton>
                        </div>
                        
                        {/*<div className="share-buttons-box-network">*/}
                        {/*    <LinkedinShareButton*/}
                        {/*        url={this.props.shareURL}*/}
                        {/*        className="share-button-network" >*/}
                        
                        {/*        <LinkedinIcon size={42} round/>*/}
                        {/*    </LinkedinShareButton>*/}
                        {/*</div>*/}
                        
                        {/*{*/}
                        {/*    window.isSecureContext && navigator.clipboard &&*/}
                        <div className="share-buttons-box-network">
                        <span onClick={this.onClickCopyLink} className="socialCircle shadow-hover">
                            <span className="las la-link"/>
                        </span>
                        </div>
                        {/*}*/}
                    </div>
                }
            </div>
        );
    }
    
    onClickCopyLink(event) {
        console.log("ShareButtonsBox::onClickCopyLink()");
        
        /* Get the text field */
        // var copyText = document.getElementById("myInput");
        var copyText = {
            value: (this.props.shareURL.endsWith("/") ? this.props.shareURL : this.props.shareURL + "/") + "?utm_source=copylink"
        };
        
        //console.log(("window.isSecureContext? -> " + ((window.isSecureContext) ? "true" : "false")));
        this.copyLinkToClipboard(copyText.value)
            .then((result) => {
                console.log("ShareButtonsBox::onClickCopylink()");
                this.props.onClickShareButton(SOCIAL_MEDIA.COPYLINK)
                Alert.success('Enlace copiado', {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 1500,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-thumbs-up"
                    }
                });
            })
            .catch((err) => {
                Alert.warning('Error al copiar el enlace: copie la URL directamente', {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 3000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });
            });
        
        /* Alert the copied text */
        // alert("Copied the text: " + copyText.value);
    }
    
    copyLinkToClipboard(textToCopy) {
        console.log("ShareButtonsBox::copyLinkToClipboard()");
        return new Promise((res, rej) => {
            if (window.isSecureContext && navigator.clipboard) {
                
                /* Copy the text inside the text field */
                navigator.clipboard.writeText(textToCopy)
                    .then(() => {
                        //console.log('Async: Copying to clipboard was successful!');
                        // alert("Copied the text: " + copyText.value);
                        res()
                    })
                    .catch((err) => {
                        console.error('Async: Could not copy text: ', err);
                        // alert("Err: " + err);
                        rej()
                    });
            } else {
                let textArea = document.createElement("textarea");
                textArea.value = textToCopy;
                // make the textarea out of viewport
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                return new Promise((res, rej) => {
                    // here the magic happens
                    document.execCommand('copy') ? res() : rej();
                    textArea.remove();
                })
                    .then((result) => {
                        res()
                    })
                    .catch((err) => {
                        rej()
                    });
                
                
            }
        })
    }
}